module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "side-cover-wrapper full-screen visible-lg visible-md"
  }, [_c('div', {
    staticClass: "fslider",
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "height": "100%",
      "top": "0",
      "left": "0",
      "background-color": "#333"
    },
    attrs: {
      "data-speed": "3000",
      "data-pause": "5000",
      "data-animation": "fade",
      "data-arrows": "false",
      "data-pagi": "false"
    }
  }, [_c('div', {
    staticClass: "flexslider",
    staticStyle: {
      "height": "100% !important"
    }
  }, [_c('div', {
    staticClass: "slider-wrap",
    staticStyle: {
      "height": "inherit !important"
    }
  }, [_c('div', {
    staticClass: "slide full-screen force-full-screen",
    attrs: {
      "id": "slide1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "slide full-screen force-full-screen",
    attrs: {
      "id": "slide2"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cd9afbb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cover-photos.vue
// module id = 107
// module chunks = 1